import React from 'react';
import { Users } from 'lucide-react';

/**
 * "Teammate, not another tool" band.
 * A single, calm statement band that positions Crush as an extension of the team
 * rather than another SaaS login. Sits between ChannelExecutions and Pricing.
 */
export default function Teammate() {
  return (
    <section
      data-testid="teammate-band"
      className="py-14 sm:py-16 lg:py-20"
      style={{ backgroundColor: '#FAFAF9' }}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="rounded-3xl p-7 sm:p-10 lg:p-12 border grid lg:grid-cols-[auto_1fr] gap-6 lg:gap-10 items-start"
          style={{ backgroundColor: '#ffffff', borderColor: '#e6e2d6' }}
        >
          <span
            aria-hidden="true"
            className="inline-flex w-14 h-14 rounded-2xl items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(107,75,239,0.12)' }}
          >
            <Users size={26} strokeWidth={2.1} style={{ color: '#5132d4' }} />
          </span>
          <div>
            <p className="uppercase tracking-[0.16em] text-[11px] sm:text-xs font-semibold mb-3" style={{ color: '#5132d4' }}>
              A teammate, not another tool
            </p>
            <h3
              className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-tight"
              style={{ color: '#130F28' }}
            >
              Think of us as an extra set of hands on your team, <span className="italic" style={{ color: '#5132d4' }}>carrying the day to day of marketing alongside you.</span>
            </h3>
            <p className="mt-4 text-base sm:text-lg leading-relaxed" style={{ color: '#3b3656' }}>
              We do the heavy lifting: writing, scheduling, sending, and adjusting. You stay focused on the work only you can do, and your campaigns still go out every week, whether or not anyone had time to think about it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
